import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loading = true;
  constructor(private userService: UserService, private router: Router) {
    this.userService.getUser().subscribe(v => {
      if (v) {
        this.userService.user = v;
        this.userService.isLoggedIn = true;
        const redirect = this.userService.redirectUrl
          ? this.userService.redirectUrl
          : '/';
        this.loading = false;
        this.userService.refreshStatus();
        this.router.navigate([redirect]);
      }
      this.loading = false;
    });
  }


}
